export enum ApplicationStatus {

    New                      = 1,
    Approved                 = 2,
    Declined                 = 3,
    WaitingForConfirmation   = 4,
    Cancelled                = 5
} 